import { useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import HeroSection from "@/sections/HeroSection";
import ProblemSection from "@/sections/ProblemSection";
import SolutionSection from "@/sections/SolutionSection";
import FeaturesSection from "@/sections/FeaturesSection";
import HowItWorksSection from "@/sections/HowItWorksSection";
import DemoPreviewSection from "@/sections/DemoPreviewSection";
import WhyNowSection from "@/sections/WhyNowSection";
import SecuritySection from "@/sections/SecuritySection";
import FinalCTASection from "@/sections/FinalCTASection";
import Footer from "@/components/Footer";

export default function LandingPage() {
  useEffect(() => {
    document.title = "Runzr — The Control Plane for AI Coding Sessions";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen"
      style={{ background: "#0A0A0A" }}
      data-testid="landing-page"
    >
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <FeaturesSection />
      <HowItWorksSection />
      <DemoPreviewSection />
      <WhyNowSection />
      <SecuritySection />
      <FinalCTASection />
      <Footer />
    </motion.div>
  );
}
